module.exports = __webpack_public_path__ + "static/img/thumb-04.fcbe89f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/thaipost/thumb/thumb-04.png
// module id = mvVd
// module chunks = 150